import makeStorage from "./makeStorage";

const useSessionStorage = makeStorage(sessionStorage);

export default useSessionStorage;
